import { useState } from 'react';
import useText from 'hooks/useText';

const RESPONSES = ['accepted', 'declined', 'tentative'];

/**
 * « Participer ? Oui · Non · Peut-être », for a guest of the appointment
 * (access.canRespond). `current` is the guest's answer (myResponse), marked
 * pressed; `onRespond(response)` sends one and settles once it is done.
 */
const AppointmentResponseBar = ({ current, onRespond }) => {
  const { text } = useText('appointment');
  const [sending, setSending] = useState(false);

  const respond = async (response) => {
    setSending(true);
    try {
      await onRespond(response);
    } finally {
      setSending(false);
    }
  };

  return (
    <div
      role="group"
      aria-label={text('respondLabel')}
      className="flex flex-wrap items-center gap-2 px-4 py-3 md:px-6"
    >
      <span className="mr-auto text-sm font-medium text-gray-700">
        {text('respondLabel')}
      </span>
      {RESPONSES.map((response) => {
        const pressed = current === response;
        return (
          <button
            key={response}
            type="button"
            aria-pressed={pressed}
            disabled={sending}
            onClick={() => !pressed && respond(response)}
            className={`rounded-full border px-3 py-1 text-sm font-medium disabled:opacity-60 ${
              pressed
                ? 'border-yellow-500 bg-yellow-50 text-gray-900'
                : 'border-gray-300 bg-white text-gray-700 hover:bg-gray-50'
            }`}
          >
            {text(`respond_${response}`)}
          </button>
        );
      })}
    </div>
  );
};

export default AppointmentResponseBar;
